/**
 * Australian AI Governance Frameworks
 * Referenced across assessment questions to show regulatory mapping.
 */

export const FRAMEWORKS = {
  // ── APS AI Ethics Principles ──────────────────────────────────────────────
  APS1: {
    code: 'APS-1',
    label: 'Wellbeing',
    fullName: 'APS AI Ethics: Human, societal & environmental wellbeing',
    color: '#1D4ED8',
    bg: '#EFF6FF',
    text: '#1D4ED8',
  },
  APS2: {
    code: 'APS-2',
    label: 'Human-centred',
    fullName: 'APS AI Ethics: Human-centred values',
    color: '#1D4ED8',
    bg: '#EFF6FF',
    text: '#1D4ED8',
  },
  APS3: {
    code: 'APS-3',
    label: 'Fairness',
    fullName: 'APS AI Ethics: Fairness',
    color: '#1D4ED8',
    bg: '#EFF6FF',
    text: '#1D4ED8',
  },
  APS4: {
    code: 'APS-4',
    label: 'Privacy & Security',
    fullName: 'APS AI Ethics: Privacy protection & security',
    color: '#1D4ED8',
    bg: '#EFF6FF',
    text: '#1D4ED8',
  },
  APS5: {
    code: 'APS-5',
    label: 'Reliability & Safety',
    fullName: 'APS AI Ethics: Reliability & safety',
    color: '#1D4ED8',
    bg: '#EFF6FF',
    text: '#1D4ED8',
  },
  APS6: {
    code: 'APS-6',
    label: 'Transparency',
    fullName: 'APS AI Ethics: Transparency & explainability',
    color: '#1D4ED8',
    bg: '#EFF6FF',
    text: '#1D4ED8',
  },
  APS7: {
    code: 'APS-7',
    label: 'Contestability',
    fullName: 'APS AI Ethics: Contestability',
    color: '#1D4ED8',
    bg: '#EFF6FF',
    text: '#1D4ED8',
  },
  APS8: {
    code: 'APS-8',
    label: 'Accountability',
    fullName: 'APS AI Ethics: Accountability',
    color: '#1D4ED8',
    bg: '#EFF6FF',
    text: '#1D4ED8',
  },

  // ── DISR Responsible AI Framework ────────────────────────────────────────
  DISR_SAFE: {
    code: 'DISR-Safe',
    label: 'DISR: Safe',
    fullName: 'DISR Responsible AI: Safe',
    color: '#0D9488',
    bg: '#F0FDFA',
    text: '#0D9488',
  },
  DISR_SECURE: {
    code: 'DISR-Secure',
    label: 'DISR: Secure',
    fullName: 'DISR Responsible AI: Secure',
    color: '#0D9488',
    bg: '#F0FDFA',
    text: '#0D9488',
  },
  DISR_RELIABLE: {
    code: 'DISR-Reliable',
    label: 'DISR: Reliable',
    fullName: 'DISR Responsible AI: Reliable',
    color: '#0D9488',
    bg: '#F0FDFA',
    text: '#0D9488',
  },
  DISR_EXPLAINABLE: {
    code: 'DISR-Explainable',
    label: 'DISR: Explainable',
    fullName: 'DISR Responsible AI: Explainable',
    color: '#0D9488',
    bg: '#F0FDFA',
    text: '#0D9488',
  },
  DISR_TRANSPARENT: {
    code: 'DISR-Transparent',
    label: 'DISR: Transparent',
    fullName: 'DISR Responsible AI: Transparent',
    color: '#0D9488',
    bg: '#F0FDFA',
    text: '#0D9488',
  },
  DISR_CONTESTABLE: {
    code: 'DISR-Contestable',
    label: 'DISR: Contestable',
    fullName: 'DISR Responsible AI: Contestable',
    color: '#0D9488',
    bg: '#F0FDFA',
    text: '#0D9488',
  },
  DISR_ACCOUNTABLE: {
    code: 'DISR-Accountable',
    label: 'DISR: Accountable',
    fullName: 'DISR Responsible AI: Accountable',
    color: '#0D9488',
    bg: '#F0FDFA',
    text: '#0D9488',
  },
  DISR_FAIR: {
    code: 'DISR-Fair',
    label: 'DISR: Fair',
    fullName: 'DISR Responsible AI: Fair',
    color: '#0D9488',
    bg: '#F0FDFA',
    text: '#0D9488',
  },

  // ── ISO/IEC 42001 ─────────────────────────────────────────────────────────
  ISO42001: {
    code: 'ISO 42001',
    label: 'ISO 42001',
    fullName: 'ISO/IEC 42001 AI Management System Standard',
    color: '#7C3AED',
    bg: '#F5F3FF',
    text: '#7C3AED',
  },

  // ── Australian Privacy Act 1988 (APPs) ───────────────────────────────────
  APP1: {
    code: 'APP-1',
    label: 'Privacy: Transparency',
    fullName: 'Privacy Act APP 1: Open & transparent management of personal information',
    color: '#B45309',
    bg: '#FFFBEB',
    text: '#B45309',
  },
  APP3: {
    code: 'APP-3',
    label: 'Privacy: Collection',
    fullName: 'Privacy Act APP 3: Collection of personal information',
    color: '#B45309',
    bg: '#FFFBEB',
    text: '#B45309',
  },
  APP6: {
    code: 'APP-6',
    label: 'Privacy: Use & Disclosure',
    fullName: 'Privacy Act APP 6: Use or disclosure of personal information',
    color: '#B45309',
    bg: '#FFFBEB',
    text: '#B45309',
  },
  APP11: {
    code: 'APP-11',
    label: 'Privacy: Security',
    fullName: 'Privacy Act APP 11: Security of personal information',
    color: '#B45309',
    bg: '#FFFBEB',
    text: '#B45309',
  },
  APP12: {
    code: 'APP-12',
    label: 'Privacy: Access',
    fullName: 'Privacy Act APP 12: Access to personal information',
    color: '#B45309',
    bg: '#FFFBEB',
    text: '#B45309',
  },
};

/**
 * Returns an array of framework objects for a given list of keys.
 */
export function getFrameworks(keys = []) {
  return keys.map((k) => FRAMEWORKS[k]).filter(Boolean);
}
